import React, { useContext } from 'react';

const OverviewSection = ({ requestContext, endorsementClassStr, endorsementType }) => {
  var endorsementContext = useContext(requestContext);

  return (
    <div className='row justify-content-center my-3' style={{ paddingLeft: '5%', paddingRight: '5%' }}>
      <div className='col-12 text-center'>
        <h4 className='fw-bold text-primary' style={{ display: 'flex' }}>Overview</h4>
        <p className='fw-bold m-0' style={{ display: 'flex', paddingBottom: '10px' }}>
          The following vehicle change(s) have been requested:
        </p>

        {endorsementType == "Add Vehicle" &&
          <>
            {endorsementContext?.addVehicleClass.vehicles.vehiclesOnPolicy.newVehicles.map((vehicle, index) => (
              <p key={index} className='m-0' style={{ display: 'flex', paddingLeft: '7%' }}>
                <span className='ms-1 text-primary fw-bold'>
                  {vehicle.vehicleYear} {vehicle.vehicleMake} {vehicle.vehicleModel}
                </span>
                <span style={{ color: 'grey' }}>&nbsp;- New Vehicle</span>
              </p>
            ))}
          </>
        }

        {endorsementType == "Remove Vehicle" &&
          <>
            {endorsementContext?.removeVehicleClass.vehicles.vehiclesOnPolicy.removedVehicles.map((vehicle, index) => (
              <p key={index} className='m-0' style={{ display: 'flex', paddingLeft: '7%' }}>
                <span className='ms-1 text-primary fw-bold'>
                  {vehicle?.Year} {vehicle?.Make} {vehicle?.Model}
                </span>
                <span style={{ color: 'grey' }}>&nbsp;- Removed Vehicle</span>
              </p>
            ))}
          </>
        }

        {endorsementType == "Replace Vehicle" &&
          <>
            {endorsementContext?.replaceVehicleClass.vehicles.vehiclesOnPolicy.removedVehicles.map((vehicle, index) => (
              <p key={index} className='m-0' style={{ display: 'flex', paddingLeft: '7%' }}>
                <span className='ms-1 text-primary fw-bold'>
                  {vehicle?.Year} {vehicle?.Make} {vehicle?.Model}
                </span>
                <span style={{ color: 'grey' }}>&nbsp;- Removed Vehicle</span>
              </p>
            ))}
            {endorsementContext?.replaceVehicleClass.vehicles.vehiclesOnPolicy.newVehicles.map((vehicle, index) => (
              <p key={index} className='m-0' style={{ display: 'flex', paddingLeft: '7%' }}>
                <span className='ms-1 text-primary fw-bold'>
                  {vehicle.vehicleYear} {vehicle.vehicleMake} {vehicle.vehicleModel}
                </span>
                <span style={{ color: 'grey' }}>&nbsp;- New Vehicle</span>
              </p>
            ))}
          </>
        }
      </div>
    </div>
  );
};

export default OverviewSection;